export default __webpack_public_path__ + "f928f1be99776af83e8e6be4baf8ffe7.svg";